import merge from "../functions/merge";

export default {
	entity() {
		return merge({}, {
			_embedded: {
				
			},
			department_id: null,
			reservation_type_id: null,
			start_date: (new Date()).format('Y-m-d'),
			end_date: (new Date()).format('Y-m-d'),
			start_time: '00:00',
			end_time: '00:00',
			note: '',
			employees: [],
			vehicles: [],
			status: 'approved',
			frame: 'single'
		});
	},
	save(axios, entity) {
		return new Promise(function (resolve) {
			if (entity.id) {
				axios
					.put('/planning/reservations/' + entity.id + '/', entity)
					.then(function (r) {
						resolve(r.data);
					}, function () {
						
					});
			} else {
				axios
					.post('/planning/reservations/', entity)
					.then(function (r) {
						resolve(r.data);
					}, function () {
						
					});
			}
		});
	},
	read(axios, id) {
		return new Promise(function (resolve) {
			axios
				.get('/planning/reservations/' + id + '/')
				.then(function (r) {
					resolve(r.data);
				}, function () {
					
				});
		});
	},
	delete(axios, id) {
		return new Promise(function (resolve) {
			axios
				.delete('/planning/reservations/' + id + '/')
				.then(function () {
					resolve(true);
				}, function () {
					
				});
		});
	}
};